import { ThemeDefinition } from "@omegagrid/core";

export const tmDark: ThemeDefinition = {
	'highcharts-color-0': '#2b908f',
	'highcharts-color-1': '#90ee7e',
	'highcharts-color-2': '#f45b5b',
	'highcharts-color-3': '#7798BF',
	'highcharts-color-4': '#aaeeee',
	'highcharts-color-5': '#ff0066',
	'highcharts-color-6': '#55BF3B',
	'highcharts-color-7': '#DF5353',
	'highcharts-color-8': '#7798BF',
	'highcharts-color-9': '#aaeeee',
};

export const tmLight: ThemeDefinition = {
	'highcharts-color-0': '#2b908f',
	'highcharts-color-1': '#90ee7e',
	'highcharts-color-2': '#f45b5b',
	'highcharts-color-3': '#7798BF',
	'highcharts-color-4': '#aaeeee',
	'highcharts-color-5': '#ff0066',
	'highcharts-color-6': '#55BF3B',
	'highcharts-color-7': '#DF5353',
	'highcharts-color-8': '#7798BF',
	'highcharts-color-9': '#aaeeee',
};
